import {AnimationImage} from './animation_image';
import {calculateCover} from './image';
import {effects} from './effects';
import {px} from './css';
import {spine} from './spine-widget';
import {style} from './manipulations';
import {viewport} from './viewport';
import {wrap} from './manipulations';

const qS = document.querySelector.bind(document);

export class MountainScene {
  constructor() {
    this.ranRabbit = false;
  }

  onResize() {
    this.positionTitle();
  }

  positionTitle() {
    if (viewport.width > 639) {
      const title = qS('.mountain-scene .mountain-title');
      const cover = calculateCover(1600, 2880);
      const left = 760 * cover.scaleFactor + cover.xOffset;
      const top = 280 * cover.scaleFactor + cover.yOffset;
      const width = 450 * cover.scaleFactor;
      const height = 450 * cover.scaleFactor;
      const styles = {
        left: px(left),
        height: px(height),
        top: px(top),
        width: px(width),
      }
      style(title, styles);
    } else {
      const title = qS('.mountain-scene .mountain-title');
      const cover = calculateCover(1600, 2880);
      let left = 816 * cover.scaleFactor + cover.xOffset;
      const leftAdjustment = cover.xOffset - left;
      const background = qS('.mountain-scene .background');
      background.style['background-position'] = leftAdjustment + 'px 0';
      left = 10;
      const top = 260 * cover.scaleFactor + cover.yOffset;
      const width = 450 * cover.scaleFactor;
      const height = 450 * cover.scaleFactor;
      const styles = {
        left: px(left),
        height: px(height),
        top: px(top),
        width: px(width),
      }
      style(title, styles);
    }
  }

  run() {
    window.addEventListener('resize', this.onResize.bind(this));
    this.positionTitle();
    this.runRabbit();
  }

  runRabbit() {
    if (this.ranRabbit) {
      return;
    }
    this.ranRabbit = true;
    const origWidth = 1920;
    const origHeight = 1440;
    const cover = calculateCover(origHeight, origWidth);
    const left = 900 * cover.scaleFactor + cover.xOffset
    const top = -200 * cover.scaleFactor + cover.yOffset;
    const options = {
      alpha: true,
      animation: 'climbing',
      atlas: 'themes/custom/giantrabbit/spine/skeleton.atlas',
      backgroundColor: '#00000000',
      fitToCanvas: false,
      json: 'themes/custom/giantrabbit/spine/skeleton.json',
      loop: false,
      scale: cover.scaleFactor,
      x: left,
      y: top,
    };
    this.rabbitClimbing = new spine.SpineWidget('rabbit-climbing', options);
  }
}
